/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const controlsRepeat = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M5 7v3l-2 1.5V5h11V3l4 3.01L14 9V7H5zm10 6v-3l2-1.5V15H6v2l-4-3.01L6 11v2h9z" />
	</SVG>
);

export default controlsRepeat;
